import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { swalMessages, permitsList } from 'src/constants';
import swal from 'sweetalert';
import EntriesQueue from 'src/pages/InsigthFactory/EntriesQueue';
import {
  getQueueEntries,
  rejectEntries,
} from 'src/services/entriesQueueServices';
import { Context } from 'src/context/Contex';
import filterArray from 'src/utils/filterArray';
import pagination from 'src/utils/pagination';

const EntriesQueueContainer = () => {
  const [postPerPage] = useState(5);
  const [entries, setEntries] = useState([]);
  const [formDialog, setFormDialog] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [indexItem, setIndexItem] = useState(null);
  const { unidad, permisos } = useContext(Context);

  const history = useHistory();

  const permitValue = permisos[permitsList.FABRICA_INSIGHTS];
  const filteredItems = unidad
    ? filterArray(entries, 'id_unidad_negocio', unidad)
    : [];

  // paginacion
  const onChangePage = (e, page) => {
    setCurrentPage(page);
  };

  const { currentPosts } = pagination(filteredItems, currentPage, postPerPage);
  const { totalPages } = pagination(filteredItems, currentPage, postPerPage);

  const onChangeInput = (event) => {
    const input = event.target.value;
    setFormDialog(input);
  };

  // dialog actions
  const onOpenDialog = (index) => {
    setOpenDialog(true);
    setIndexItem(index);
  };
  const onCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleReject = async (event) => {
    event.preventDefault();
    const { id } = currentPosts[indexItem];
    const motivoRechazo = formDialog;
    const { success } = await rejectEntries({
      id,
      motivoRechazo,
      tipo: 'rechazar',
    });
    if (success) {
      const updatedEntries = entries.filter((entry) => entry.id !== id);
      const updatedCurrent = currentPosts.filter((entry) => entry.id !== id);
      setEntries(updatedEntries);
      if (updatedCurrent.length === 0) {
        setCurrentPage(1)
      }
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };
  // servicios iniciales
  const fetchEntries = async () => {
    const { success, data } = await getQueueEntries();
    if (success) {
      setEntries(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };
  const onEvaluate = (entryId) => {
    const state = entries.filter((entry) => entry.id === entryId).pop();
    history.push(`/insight_factory/questions/${entryId}`, state);
  };

  useEffect(() => {
    fetchEntries();
  }, []);

  return (
    <EntriesQueue
      permitValue={permitValue}
      entries={currentPosts}
      totalPages={totalPages}
      openDialog={openDialog}
      handleReject={handleReject}
      onChangePage={onChangePage}
      onOpenDialog={onOpenDialog}
      onCloseDialog={onCloseDialog}
      onChangeInput={onChangeInput}
      onEvaluate={onEvaluate}
    />
  );
};

export default EntriesQueueContainer;
